import { ListingStatus } from '@/domain/units';
import { Link } from '@tanstack/react-router';
import type { FC } from 'react';

interface Props {
  showApplyButtons?: boolean;
  unitId: number;
  unitListingStatus: ListingStatus | undefined;
}

const PropertyCardActions: FC<Props> = ({ unitId, showApplyButtons, unitListingStatus }) => {
  if (!showApplyButtons) {
    return (
      <Link to="/units" search={{ unitId }} className="block w-full text-center btn-primary">
        View Details
      </Link>
    );
  }

  return (
    <>
      {unitListingStatus === ListingStatus.COMING_SOON ? (
        <button
          className="block w-full text-center py-3 rounded-none font-semibold transition-colors bg-gray-300 text-gray-600 cursor-not-allowed mb-3"
          disabled
        >
          Coming Soon
        </button>
      ) : (
        <div className="flex flex-col sm:flex-row gap-2 mb-3">
          <Link
            to="/units"
            search={{ unitId }}
            className="flex-1 text-center btn-primary whitespace-nowrap px-3"
          >
            View Details
          </Link>
          <Link
            to="/contact"
            search={{ unitId }}
            className="flex-1 text-center btn-outline whitespace-nowrap px-3"
          >
            Schedule Tour
          </Link>
        </div>
      )}
      <Link to="/apply" search={{ unitId }} className="block w-full text-center btn-outline">
        Apply
      </Link>
    </>
  );
};

export default PropertyCardActions;
